import { useQuery } from "react-query";
import axios from "axios";

const getPosts = async ({
  companyId,
  publishedState,
  authorDetails,
  events,
  limit,
  offset,
  sortBy,
  orderBy,
}) => {
  let pathAndHost = window.location.protocol + window.location.host;

  let url = new URL(`/api/v2/companies/${companyId}/posts`, pathAndHost);

  if (publishedState) {
    url.searchParams.append("published_state", publishedState);
  }

  if (authorDetails) {
    url.searchParams.append("author_details", authorDetails);
  }

  if (events !== undefined) {
    url.searchParams.append("events", events);
  }

  if (offset !== undefined) {
    url.searchParams.append("offset", offset);
  }

  if (limit !== undefined) {
    url.searchParams.append("limit", limit);
  }

  if (sortBy !== undefined) {
    url.searchParams.append("sort_by", sortBy);
  }

  if (orderBy !== undefined) {
    url.searchParams.append("order_by", orderBy);
  }

  const { data: posts } = await axios.get(url.href);

  return posts;
};

export default function usePosts({
  companyId,
  publishedState,
  authorDetails,
  events,
  limit,
  offset,
  sortBy,
  orderBy,
  refetchOnWindowFocus = true,
}) {
  return useQuery(
    [
      "companies",
      companyId,
      "posts",
      {
        publishedState,
        authorDetails,
        events,
        limit,
        offset,
        sortBy,
        orderBy,
      },
    ],
    () =>
      getPosts({
        companyId,
        publishedState,
        authorDetails,
        events,
        limit,
        offset,
        sortBy,
        orderBy,
      }),
    {
      enabled: companyId !== undefined,
      refetchOnWindowFocus: refetchOnWindowFocus,
    }
  );
}
